import { ReactElement, useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import useStoreysForSeismic from '../../../../hooks/useStoreysForSeismic'
import StoreyCentroidMarkers from './StoreyCentroidMarkers'
import { toStoreyElevations } from './utils'

/**
 * Marks the mass and stiffness centroid of every storey in the scene, in the
 * same colours their input fields carry, so the multi-mass oscillator the
 * procedure builds can be read off the model directly.
 *
 * Positions come from the live form values - including the storey heights,
 * which stack into the elevation each centroid sits at, exactly as the
 * substitute force calculation derives it. This component therefore has to be
 * rendered inside the model data form.
 */
const SeismicCentroidSceneMarkers = (): ReactElement => {
  const storeys = useStoreysForSeismic()
  const storeyInputs = useWatch({ name: 'data' })

  const elevations = useMemo(
    () => toStoreyElevations(storeyInputs, storeys),
    [storeyInputs, storeys],
  )

  return (
    <>
      {storeys.map(storey => (
        <StoreyCentroidMarkers
          key={storey}
          massLocation={storeyInputs?.[storey]?.mass_point?.location}
          stiffnessLocation={storeyInputs?.[storey]?.stiffness_point?.location}
          elevation={elevations[storey]}
        />
      ))}
    </>
  )
}

export default SeismicCentroidSceneMarkers
